import React from 'react';
import type { FunctionComponent } from 'react';
import './Loader.scss';
import { getClasses } from '@utils';
import { Loading } from '@web-components-proxy';

export interface LoaderInterface {
	size?: string;
	fullscreen: boolean;
}

export const Loader: FunctionComponent<LoaderInterface> = ({ size, fullscreen }: LoaderInterface) => {
	return (
		<div
			className={getClasses({
				'loader-wrapper': true,
				'loader-wrapper-fullscreen': fullscreen,
			})}
		>
			<Loading class="loader" loader-size={size} active={true} cover={true}></Loading>
		</div>
	);
};
